import { useEffect, useRef } from "react";
import { useSeller } from "../../../hooks/useAccount";
import { useStripeTerminal } from "../../../hooks/useStripeTerminal";
import { useCreatePurchaseStore } from "../../../stores/createPurchaseStore";
import { getPairedDevice } from "../../Input/EmvInput";

export const useInitializeEmv = () => {
    const seller = useSeller();

    const isInitialized = useRef<boolean>(false);
    const isEMV = useCreatePurchaseStore((state) => state.isEMV);

    const terminal = useStripeTerminal(); // Initialize early so it's ready by the time you get to the next screen

    useEffect(() => {
        if (terminal && getPairedDevice(seller) && !isEMV && !isInitialized.current) {
            console.log("EMV: Enabling EMV because reader is connected");
            isInitialized.current = true;
            useCreatePurchaseStore.getState().actions.setIsEMV(true);
        }
    }, [terminal, seller, isEMV]);

    useEffect(() => {
        /** Is `isEMV` value is set to `true` from any other place such as `useStripeTerminal.ts`, even then we need to mark `isInitialized` as `true` */
        if (isEMV && !isInitialized.current) {
            isInitialized.current = true;
        }
    }, [isEMV]);
};
